/**
 * Analytics selectors (PX-W6.4). Straight projections — the velocity answer
 * (including its `available:false` branch) reaches the page untouched.
 */

import type { GateCycleTimeSummary, VelocityResponse } from './types'
import type { AnalyticsState } from './slices/analyticsSlice'

interface WithAnalytics {
  analytics: AnalyticsState
}

export const selectCycleTime = (s: WithAnalytics): GateCycleTimeSummary | null =>
  s.analytics.cycleTime
export const selectVelocity = (s: WithAnalytics): VelocityResponse | null => s.analytics.velocity
export const selectAnalyticsLoading = (s: WithAnalytics): boolean =>
  s.analytics.caches.cycleTime.loading || s.analytics.caches.velocity.loading
export const selectAnalyticsError = (s: WithAnalytics) => s.analytics.error
